import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      notes="Eva presentation introduction"
      transition="fade"
      visualizer="hidden"
      networkBackground="full"
    >
      <div className="relative z-10 flex flex-col items-center justify-center h-full">
        <h1 className="title">EVA</h1>
        <p className="subtitle">Enterprise Virtual Assistant</p>
        <p className="byline">door Jonathan IJzerman</p>
      </div>
    </Slide>
  );
};
